// AMUMIN Admin (wave 4). English counterpart of beheerApp.nl.ts.
export const appBeheerEn = {
    nav: 'Customers',
    title: 'Admin',
    subtitle: 'Only for you as admin · account details only, never what a family plans',
    tabs: {
        label: 'Admin sections',
        households: 'Households',
        accounts: 'Account help',
        audit: 'What admin did',
        short: { households: 'Households', accounts: 'Accounts', audit: 'Log' },
    },
    status: {
        networkOk: 'Trusted network',
        networkNo: 'No trusted network',
        reauthUntil: 'You can make changes until {time}',
        reauthNeeded: 'Confirm first to change anything',
        reauthButton: 'Confirm',
    },
    network: {
        title: 'Admin only works at home or at the office',
        body: 'You are on another network right now. Open Admin from home or the office; on this network you cannot see or change anything.',
    },
    reauth: {
        title: 'Confirm it is you',
        intro: 'Changes in Admin need your password or an email code. After that you can make changes for {minutes} minutes.',
        password: 'Password',
        confirm: 'Confirm',
        wrong: 'This password is not correct.',
        orCode: 'Prefer a code by email?',
        sendCode: 'Send a code',
        codeSent: 'We sent a code to {email}.',
        code: 'Code from the email',
        confirmCode: 'Confirm code',
        codeWrong: 'This code is not correct. Please check your email again.',
        done: 'Confirmed. You can make changes now.',
    },
    list: {
        search: 'Search by name or email address',
        searchButton: 'Search',
        clear: 'Show all',
        new: 'New household',
        count: { one: '{count} household', other: '{count} households' },
        emptyTitle: 'No households found',
        emptyBody: 'Search for another word, or create a new household for a customer.',
        members: { one: '{count} family member', other: '{count} family members' },
        logins: { one: '{count} login', other: '{count} logins' },
        devices: { one: '{count} tablet', other: '{count} tablets' },
        created: 'Since {date}',
        lastActive: 'Last active {date}',
        neverActive: 'Not active yet',
        modulesAll: 'All modules on',
        modulesOff: { one: '{count} module off', other: '{count} modules off' },
        open: 'Open',
    },
    state: {
        active: 'Active',
        invited: 'Invitation open',
        paused: 'Paused',
        deletion_scheduled: 'Being deleted',
    },
    plans: {
        founder: 'Founder',
        free: 'Free',
        family: 'Family',
        family_plus: 'Family plus',
    },
    create: {
        title: 'New household for a customer',
        intro: 'The owner gets an invitation by email and chooses their own password there. You never see that password.',
        name: 'Household name',
        namePlaceholder: 'The Jansen family',
        email: 'Email address of the owner',
        plan: 'Plan',
        submit: 'Create and send invitation',
        done: 'Created. The invitation went to {email}.',
    },
    detail: {
        back: 'All households',
        facts: 'About this household',
        plan: 'Plan',
        created: 'Created',
        lastActive: 'Last active',
        people: 'Family',
        modules: 'Modules',
        id: 'Number',
        actions: 'What can you do?',
        pause: 'Pause',
        pauseBody: 'The family can then only look. The app and the board show a calm message; nothing is lost.',
        pauseReason: 'Why? (only for your log, 24 months; no names or other personal data)',
        pauseConfirm: 'Yes, pause',
        paused: 'Paused since {date}. The family can only look.',
        resume: 'Make active again',
        resumed: 'The family can use everything again.',
        pausedDone: 'Paused. The family can only look now.',
        resendInvite: 'Send invitation again',
        resendDone: 'New invitation sent to {email}. The previous link no longer works.',
        deletion: 'Schedule deletion',
        deletionBody: 'The family first gets a cooling-off period. After that everything is deleted. You can still cancel during that time.',
        deletionConfirm: 'Yes, schedule deletion',
        deletionCancel: 'Cancel deletion',
        deletionScheduled: 'Will be deleted after {date}.',
        deletionByOwner: 'The owner asked for this themselves. Only the family can stop it (in the app: Do not delete).',
        deletionByPlatform: 'Scheduled by AMUMIN Admin.',
        deletionOwnerRequested: 'The owner asked for the deletion themselves; only the family can stop it.',
        deletionUnavailable: 'Deletion with a cooling-off period is coming soon. Nothing was changed.',
    },
    support: {
        title: 'Look along',
        none: 'The owner has not allowed looking along. Ask the family to switch it on in Settings, under "Look along by AMUMIN".',
        allowed: 'The owner lets you look along until {date}. Every time you look, the family sees it.',
        open: 'Look along (read only)',
        heading: 'This is what the board looks like',
        readOnly: 'Read only · the family sees that you are looking',
        members: 'Family',
        login: 'with login',
        noLogin: 'without login',
        rooms: 'Rooms',
        devices: 'Tablets',
        deviceSeen: 'seen {date}',
        deviceNever: 'not seen yet',
        noDevices: 'No tablet paired yet',
        deviceVersion: 'version {version}',
        outbox: { one: '{count} tap waiting', other: '{count} taps waiting' },
        week: 'Next 7 days',
        nothing: 'Nothing planned',
        allDay: 'All day',
        everyone: 'Everyone',
        cancelled: 'cancelled',
        notGranted: 'Looking along is not (or no longer) allowed.',
    },
    accounts: {
        title: 'Account help',
        intro: 'Help a customer who cannot sign in. You never see a password and you cannot set one either.',
        email: 'Email address of the customer',
        lookup: 'Look up',
        notFound: 'No account with {email}.',
        found: 'Account {email}',
        verified: 'Email address confirmed',
        notVerified: 'Email address not confirmed yet',
        locked: 'Locked after too many attempts',
        lockedUntil: 'Locked until {time}',
        notLocked: 'Not locked',
        sessions: { one: '{count} active session', other: '{count} active sessions' },
        households: { one: 'In {count} household', other: 'In {count} households' },
        lastLogin: 'Last signed in {date}',
        neverLoggedIn: 'Never signed in',
        actions: {
            resend_verification: 'Send confirmation email again',
            unlock: 'Remove the lock',
            sign_out_everywhere: 'Sign out everywhere',
        },
        done: {
            resend_verification: 'New confirmation email sent.',
            unlock: 'The lock is removed. The customer can sign in again.',
            sign_out_everywhere: 'The customer is signed out everywhere.',
        },
        nothing: {
            resend_verification: 'This address is already confirmed.',
            unlock: 'This account was not locked.',
            sign_out_everywhere: 'There were no active sessions.',
        },
    },
    audit: {
        title: 'What admin did',
        intro: 'Everything that happens in Admin is listed here. Nobody can change this log.',
        empty: 'Nothing done in Admin yet.',
        actions: {
            'platform.household.create': 'Household created',
            'platform.invitation.resend': 'Invitation sent again',
            'platform.household.pause': 'Paused',
            'platform.household.resume': 'Made active again',
            'platform.household.deletion_schedule': 'Deletion scheduled',
            'platform.household.deletion_cancel': 'Deletion cancelled',
            'platform.support.view': 'Looked along',
            'platform.account.lookup': 'Account looked up',
            'platform.account.resend_verification': 'Confirmation email sent again',
            'platform.account.unlock': 'Lock removed',
            'platform.account.sign_out_everywhere': 'Signed out everywhere',
        },
        unknownAction: 'Action in Admin',
        gone: 'deleted household',
    },
    settings: {
        title: 'Look along by AMUMIN',
        intro: 'Need help? AMUMIN can look along for a while, read only. You decide how long, and any parent can always stop it right away.',
        sees: 'AMUMIN then sees: the names of all family members (children too), the titles of events for today and the next 6 days (a title can say something like Dentist; events with a faith icon such as mosque or church are left out), the rooms and the tablets. Not: faith, health, school, email addresses or photos. Every time AMUMIN looks along is listed below.',
        off: 'Off. Nobody at AMUMIN can see your family board.',
        on: 'AMUMIN may look along until {date}.',
        howLong: 'How long?',
        choices: { 1: '1 hour', 24: '1 day', 72: '3 days', 168: '7 days' },
        grant: 'Allow looking along',
        granted: 'AMUMIN may look along now.',
        revoke: 'Stop now',
        revoked: 'Looking along has stopped.',
        ownerOnly: 'Only the owner of the household can switch this on.',
        views: 'When did AMUMIN look along?',
        viewed: 'AMUMIN Admin looked along on {date}',
        noViews: 'AMUMIN has not looked along yet.',
    },
    paused: {
        title: 'Your family board is read-only for now',
        body: 'You can look at everything. Changes work again as soon as AMUMIN switches the board back on. Questions? Contact AMUMIN.',
    },
    invite: {
        title: 'Welcome to AMUMIN Family Board',
        intro: 'You are invited as the owner of the family board "{name}".',
        forEmail: 'This invitation is for {email}.',
        yourName: 'What is your name?',
        password: 'Choose a password',
        passwordHint: 'At least 12 characters. Only you know it, AMUMIN does not.',
        passwordRepeat: 'Your password once more',
        mismatch: 'The two passwords are not the same.',
        submit: 'Create account',
        doneTitle: 'Your account is ready',
        doneBody: 'Sign in now. The first time we also ask for a code from your email.',
        login: 'Sign in',
        existingTitle: 'You already have an account',
        existingBody: 'Sign in with {email} and then accept the invitation.',
        accept: 'Accept invitation',
        accepted: 'Done. The family board is yours.',
        toBoard: 'To the family board',
        invalidTitle: 'This invitation no longer works',
        invalidBody: 'The link has expired or was already used. Ask AMUMIN for a new invitation.',
        wrongAccount: 'You are signed in with another address. Sign out and sign in with the address from the invitation.',
    },
};
//# sourceMappingURL=beheerApp.en.js.map